module.exports = __webpack_public_path__ + "img/table.b3798561.png";